<template>
  <g clip-path="url(#clip0_9931_22685)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.38462 1.23047V8.61508H14.7692C14.7692 12.6935 11.463 15.9997 7.38462 15.9997C3.30621 15.9997 0 12.6935 0 8.61508C0 4.53667 3.30621 1.23047 7.38462 1.23047Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.61548 0V7.38462H16.0001C16.0001 3.30621 12.6939 0 8.61548 0Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_9931_22685">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
